export const APPROVAL_STATUS_LABEL: Record<string, string> = {
  PENDING: 'common.pending.approval',
  DRAFT: 'DRAFT',
  APPROVED: 'form.builder.approved',
  REJECTED: 'common.rejected',
};
